import React from "react";
import {CommunityCard} from "../../../library/components/reorganize/community-card";

// todo cleanup and remove these
export default function CommunityItem({data, card_style, card_obj, goTo}) {
    return <CommunityCard card_style={card_style} card_obj={card_obj}
                          goTo={() => goTo(`/${data.handle}/home`)}/>
}